export const getScarvesData = state =>
    state.globalData.scarvesData;
